import React from 'react';
import { useAjustes } from '../../Context/AjustesContext';

// Componente para mostrar as estatísticas do sistema para administradores
const SistemaInfo = ({ infoSistema }) => {
	const { ajustes } = useAjustes();

	return (
		<div className="card-flag-dashboard rounded w-100 overflow-hidden mb-4 d-none d-md-block position-relative">
			<img 
				src={ajustes?.flag ? ajustes.flag : "./../assets/flag.png"} 
				alt="" 
				className="card-img w-100 img-banner" 
				onError={(e) => {
					e.target.onerror = null;
					e.target.src = "./../assets/flag.png";
				}}
			/>
			
			<div className="info-sistema position-absolute w-100 h-100 top-0 left-0 p-4" style={{ backdropFilter: 'blur(8px)', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
				<h5 className="fw-semibold text-white mb-4">Informações do Sistema</h5>
				<div className="row">
					<div className="col-md-3 col-6 mb-3">
						<div className="d-flex flex-column align-items-center rounded bg-white p-3" style={{ boxShadow: '0 4px 8px rgba(0,0,0,0.2)' }}>
							<div className="fs-2 text-primary mb-2">
								<i className="bi bi-people-fill"></i>
							</div>
							<span className="fw-bold fs-4 text-primary">{infoSistema.total_alunos}</span>
							<span className="fw-medium fs-7 text-dark">Alunos</span>
						</div>
					</div>
					<div className="col-md-3 col-6 mb-3">
						<div className="d-flex flex-column align-items-center rounded bg-white p-3" style={{ boxShadow: '0 4px 8px rgba(0,0,0,0.2)' }}>
							<div className="fs-2 text-primary mb-2">
								<i className="bi bi-book-fill"></i>
							</div>
							<span className="fw-bold fs-4 text-primary">{infoSistema.total_cursos}</span>
							<span className="fw-medium fs-7 text-dark">Cursos</span>
						</div>
					</div>
					<div className="col-md-3 col-6 mb-3">
						<div className="d-flex flex-column align-items-center rounded bg-white p-3" style={{ boxShadow: '0 4px 8px rgba(0,0,0,0.2)' }}>
							<div className="fs-2 text-primary mb-2">
								<i className="bi bi-award-fill"></i>
							</div>
							<span className="fw-bold fs-4 text-primary">{infoSistema.total_certificados}</span>
							<span className="fw-medium fs-7 text-dark">Certificados</span>
						</div>
					</div>
					<div className="col-md-3 col-6 mb-3">
						<div className="d-flex flex-column align-items-center rounded bg-white p-3" style={{ boxShadow: '0 4px 8px rgba(0,0,0,0.2)' }}>
							<div className="fs-2 text-primary mb-2">
								<i className="bi bi-check2-circle"></i>
							</div>
							<span className="fw-bold fs-4 text-primary">{infoSistema.total_aulas_concluidas}</span>
							<span className="fw-medium fs-7 text-dark">Aulas Concluídas</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SistemaInfo; 